import * as React from 'react';
import { Responsive } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import { Heart16 } from '@cian/ui-kit/icons';

import * as styles from './Favorites.css';

export interface IFavoritesProps {
  onClick(event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>): void;
}

export const Favorites: React.FunctionComponent<IFavoritesProps> = ({ onClick }) => {
  return (
    <>
      <Responsive phone>
        <div className={styles['icon']} onClick={onClick}>
          <Heart16 color="error_100" />
        </div>
      </Responsive>
      <Responsive tablet>
        <Button size="XS" beforeIcon={<Heart16 color="primary_100" />} theme="stroke_primary" onClick={onClick}>
          В избранном
        </Button>
      </Responsive>
    </>
  );
};
